import React, { useContext, useEffect } from 'react'
import { motion } from 'framer-motion/dist/framer-motion'
import parse, { domToReact } from 'html-react-parser'

import { UIContext } from '../../../Context/UIContext'

import './Clients.scss'

import Section from '../../Section'
import Client from './Client'
import MotionModal from '../../Modal'

const options = {
    replace: ({ attribs, children }) => {
        if (!attribs) return;

        const tagNames = ['h1', 'h2', 'h3', 'p', 'ul'];
        const tagName = attribs.tagName;

        if (tagNames.includes(tagName)) {
            if (tagName === 'ul') {
                return (
                    <ul>
                        {children.map((child, i) => 
                            <li key={`sub-item-${i}`}>
                                {domToReact(child.children, options)}
                            </li>
                        )}
                    </ul>
                );
            } else {
                return React.createElement(tagName, {}, domToReact(children, options));
            }
        }
    }
}
const containerMob = {
    hidden: { opacity: 0, y: '20%' },
    show: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.8,
            delay: 1.5,
        }
    }
}
const container = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: {
            duration: 0.3,
            staggerChildren: 0.2,
            delayChildren: 1,
        }
    }
}

const Clients = ({ data }) => {
    const { title, content } = data

    const { modalVisible, setSelectedModal, isTablet } = useContext(UIContext)

    useEffect(() => {
        if (!modalVisible) {
            setSelectedModal(null)
        }
    }, [modalVisible, setSelectedModal])

    return (
        <>
            <Section
                name="mga-clients"
                className="mga-clients-section"
                motionProps={{
                    initial: { opacity: 0 },
                    animate: { opacity: 1 },
                    exit: { opacity: 0 },
                    transition: { duration: 0.5 }
                }}
            >
                <div className="mga-clients-section__wrapper">
                    <motion.h1
                        className="mga-clients-section__title"
                        initial={{ opacity: 0, x: '-50%' }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1, type: 'tween' }}
                    >
                        { title }
                    </motion.h1>
                    <motion.div
                        className="mga-clients-section__intro"
                        initial={{ opacity: 0, y: '100%' }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, delay: 0.5 }}
                    >
                        { parse(content.intro, options) }
                    </motion.div>
                    {content.clients &&
                        <motion.ul
                            className="mga-clients-section__grid"
                            initial="hidden"
                            variants={isTablet ? containerMob : container}
                            animate="show"
                        >
                            {content.clients.map((item, i) =>
                                <Client key={`client-${i}`} data={item} />
                            )}
                        </motion.ul>}
                </div>
            </Section>
            <MotionModal key="clients-global-modal" />
        </>
    )
}

export default React.memo(Clients)
